module.exports = __webpack_public_path__ + "img/27-produtividade-resumo-show.b7b36b57.png";